import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';

export interface CommitmentCardData {
  heading: string;
  frequencyAbbr: string;
  commitments: GraphQLCommitment[];
}

export const getCommitmentTotal = (commitments: GraphQLCommitment[]) =>
  commitments.reduce(
    (acc, commitment) => (commitment?.rate ? acc + commitment.rate : acc),
    0,
  );
